export function validateNumber(num: number | string | undefined) {
  if (typeof num === 'undefined') return undefined;
  if (+num < 0) return undefined;
  return !num && num !== 0 ? undefined : +num;
}

